import React from "react";
import "./Card.css";

const Card = ({ title, children, footer, className = "", style, ...rest }) => {
  // `style` et les attributs data-*/aria-* sont transmis au conteneur (ex. data-chart-title pour
  // la capture des graphiques à l'export). Avant, ils étaient silencieusement ignorés.
  return (
    <div className={`ui-card ${className}`} style={style} {...rest}>
      {title && <div className="ui-card-header">{title}</div>}
      <div className="ui-card-body">{children}</div>
      {footer && <div className="ui-card-footer">{footer}</div>}
    </div>
  );
};

export default Card;
